/**
 * Context
 *
 * Update classes for a swapped page
 */

import PubSub from 'pubsub-js';

class Context {

    //headerClassesCache = {};

    constructor() {

        // on every page load
        htmx.on('htmx:load', (htmxEvent) => {

            // update style
            let styleElm = document.querySelector('[data-style-context]');
            let body = document.querySelector('body');
            if (styleElm) {
                body.setAttribute('data-style', styleElm.dataset.styleContext);
            }

            // update locale
            let localeElms = document.querySelectorAll('[data-locale]');
            for (let [i, localeElm] of [...localeElms].entries()) {
                let locale = localeElm.dataset.locale;
                let newLocale = document.querySelector('[data-locale-' + locale + ']');
                if (newLocale) {
                    localeElm.setAttribute('href', newLocale.getAttribute('data-locale-' + locale) + '?notify=locale');
                }
                newLocale = null;
            }

            // cleanup
            styleElm = null;
            body = null;
            localeElms = null;
        });

        // when a page is swapped
        PubSub.subscribe('htmx:beforeSwap', (e, htmxEvent) => {

            if (htmxEvent.target.id === 'main') {
                let incomingDOM = new DOMParser().parseFromString(htmxEvent.detail.xhr.response, "text/html");

                // Update style
                let newStyleElm = incomingDOM.querySelector('[data-style-context]');
                let body = document.querySelector('body');
                if (newStyleElm && body) {
                    body.setAttribute('data-style', newStyleElm.dataset.styleContext);
                }

                // Update locale URL
                let localeElms = document.querySelectorAll('[data-locale]');
                for (let [i, localeElm] of [...localeElms].entries()) {
                    let locale = localeElm.dataset.locale;
                    let newLocale = incomingDOM.querySelector('[data-locale-' + locale + ']');
                    if (newLocale) {
                        localeElm.setAttribute('href', newLocale.getAttribute('data-locale-' + locale) + '?notify=locale');
                    }
                    newLocale = null;
                }

                // Transpose <meta> data, page-specific <link> tags and JSON-LD structured data
                // Note that hx-boost automatically swaps the <title> tag
                let selector = "head > meta:not([data-revision]), head *[rel=\"canonical\"], head *[rel=\"alternate\"], body script[type=\"application/ld+json\"]";
                let metadata = document.querySelectorAll(selector);
                metadata.forEach((e) => {
                    e.parentNode.removeChild(e);
                });
                incomingDOM.querySelectorAll(selector).forEach((e) => {
                    if (e.tagName === 'SCRIPT') {
                        document.body.appendChild(e);
                    } else {
                        document.head.appendChild(e);
                    }
                });

                // clean up
                body = null;
                metadata = null;
                incomingDOM = null;
                localeElms = null;
                newStyleElm = null;
            }
        });
    }
}

export default Context;